import { resetFiltersAction } from '@redux/filters/filters'

export const ADVANCED_FILTERS = {
  APPLY: 'APPLY_ADVANCED_FILTERS',
  RESET: 'RESET_ADVANCED_FILTERS'
}

// Commit the draft advanced filters to the store. Resetting the quick filters
// alongside both restarts pagination at page 1 and triggers the list refetch
// (WorkorderList watches state.filters); the fetch action then serializes the
// committed advanced filters into workorders_filter_form[...] params.
export const applyAdvancedFiltersAction = filters => dispatch => {
  dispatch({ type: ADVANCED_FILTERS.APPLY, payload: { filters } })
  dispatch(resetFiltersAction())
}
